module.exports = __webpack_public_path__ + "img/post-facebook-footer.fce86ee1.jpg";